import { useQuery } from "@tanstack/react-query";

import useSystemStore from "@store/useSystemStore";
import companyService from "@services/company.service";

import { FIND_COMPANY_BY_WEBSITE_QUERY_KEY, QUERY_CACHE_DEFAULT_EXPIRATION_MS } from "@config/query";

export function useFindCompanyByWebsite(website: string) {
  const { isAppActive } = useSystemStore();

  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    enabled: isAppActive && !!website,
    queryKey: [FIND_COMPANY_BY_WEBSITE_QUERY_KEY, website],
    queryFn: async () => {
      return await companyService.getCompanyByWebsite(website);
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    refetchOnMount: false,
    retryOnMount: false,
    retry: false,
  });

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
